import React, { useContext, useEffect } from "react"

import MicrocopyContext from "~contexts/MicrocopyContext"
import * as style from "./Changelog.module.scss"

import Filters from "./Filters"
import Entries from "./Entries"

const Changelog = ({ title, engine }) => {
  const microcopy = useContext(MicrocopyContext)

  useEffect(() => {
    engine.collapse()
  }, [])
  useEffect(() => {
    engine.fetchLatest()
  }, [])
  useEffect(() => {
    engine.paginateTo(document.location.hash)
  }, [engine.state.entries])

  return (
    <div className={style.changelog}>
      <header>{title}</header>
      <Filters engine={engine} mobile />
      <Entries engine={engine} microcopy={microcopy} />
    </div>
  )
}

export default Changelog
export { default as Filters } from "./Filters"
export { default as Engine } from "./Engine"
export { default as initialState } from "./initialState"
export { default as Bell } from "./Bell"
